import Bowser from "bowser";

export const clientEnvIsAndroid = () => {
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "android";
};
